/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from "react";
import {
    LicenseInfo,
    DataGridPro,
    GridOverlay,
    useGridApiRef,

} from "@mui/x-data-grid-pro";
import {
    styled,
    Box,
} from "@mui/material";
import {
    ExpandMore,
    ExpandLess,
    Add,
    UnfoldMore,
    SaveAlt,
} from "@mui/icons-material";
import PropTypes from "prop-types";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { currentLanguage } from "service/CommonFunction/AxiosConfig";

LicenseInfo.setLicenseKey(
    "5b31a40e910ea0c2a35371ae57c5b5beT1JERVI6MzYzMjEsRVhQSVJZPTE2NzQyOTE1NTAwMDAsS0VZVkVSU0lPTj0x"
);

const StyledGridOverlay = styled(GridOverlay)(({ theme }) => ({
    flexDirection: "column",
}));

export function DataGridMuiClient(props) {
    const {
        minHeightCustom,
        onCickRow,
        maxRowNoScroll,
        sxCustomHeader,
        sxCustomTable,
        backgroundHeaderCustom,
        rows,
        Columns,
        isLoading,
        isShowCheckBox,
        disableColumnMenu,
        isRowSelectable,
        id,
        getDetailPanelContent,
        getDetailPanelHeight,
        rowReordering,
        onRowOrderChange,
        hideFooter,
        isNotShowPagination,
        initialState
    } = props;
    const apiRef = useGridApiRef();

    const CustomNoRowsOverlay = () => {
        return (
            <StyledGridOverlay>
                <Box>{currentLanguage() == "th" ? "ไม่พบข้อมูล" : "No data"}</Box>
            </StyledGridOverlay>
        );
    };

    return (
        <>
            <DataGridPro
                density="compact"
                localeText={{
                    columnsPanelHideAllButton: "ซ่อนทั้งหมด",
                    columnsPanelShowAllButton: "แสดงทั้งหมด",
                    columnsPanelTextFieldLabel: "ค้นหาคอลัมน์",
                    columnsPanelTextFieldPlaceholder: "คอลัมน์",
                    toolbarColumns: "คอลัมน์",
                    checkboxSelectionHeaderName: "เลือก",
                }}
                // getRowClassName={(params: GridRowClassNameParams) =>
                //   params.indexRelativeToCurrentPage % 2 === 0 ? "row-even" : "row-odd"
                // }
                rows={rows}
                getRowId={(item) => item.sID}
                columns={Columns}
                pagination
                initialState={initialState}
                disableSelectionOnClick
                apiRef={apiRef}
                checkboxSelection={isShowCheckBox}
                loading={isLoading}
                autoHeight={true}
                onRowClick={(e) => onCickRow(e)}
                pageSize={maxRowNoScroll}
                rowCount={rows.length || 0}
                disableMultipleColumnsSorting
                hideFooter={hideFooter ? true : false}
                hideFooterPagination={isNotShowPagination}
                hideFooterSelectedRowCount
                // paginationMode={"client"}
                components={{
                    DetailPanelExpandIcon: () => <ExpandMoreIcon />,
                    DetailPanelCollapseIcon: () => <ExpandLessIcon />,
                    Toolbar: () => null,
                    // Pagination: () => <Pagination count={4} variant="outlined" shape="rounded" />,
                    NoRowsOverlay: CustomNoRowsOverlay,
                    ColumnSortedDescendingIcon: () => <ExpandMore style={{ fontSize: "1em", color: '#ffffff' }} />,
                    ColumnSortedAscendingIcon: () => <ExpandLess style={{ fontSize: "1em", color: '#ffffff' }} />,
                    ColumnUnsortedIcon: () => <UnfoldMore sx={{ fontSize: "1em" }} />,
                    // RowReorderIcon: () => <SwapVertIcon />, //Icon Drag Drop
                }}
                disableColumnMenu={disableColumnMenu}
                isRowSelectable={isRowSelectable}
                rowThreshold={0}
                getDetailPanelHeight={getDetailPanelHeight}
                getDetailPanelContent={getDetailPanelContent}
                disableVirtualization={true}
                rowReordering={rowReordering}
                onRowOrderChange={onRowOrderChange}
                getRowHeight={() => 'auto'}
                sx={{
                    // minHeight: rows.length < maxRowNoScroll ? 0 : minHeightCustom,
                    " .MuiDataGrid-main": {
                        overflowX: "hidden",
                        overflowY: "auto",
                        ".MuiDataGrid-columnHeaders > .MuiDataGrid-columnHeadersInner > .MuiDataGrid-columnHeader--sortable > .MuiDataGrid-columnHeaderDraggableContainer > div ":
                        {
                          ".MuiDataGrid-iconButtonContainer": {
                            visibility: "initial",
                            width: "auto",
                          },
            
                        }
                      },
                    ".MuiDataGrid-renderingZone": {
                        maxHeight: 'none !important',
                    },
                    ".MuiDataGrid-row": {
                        "&:nth-of-type(even)": {
                            background: "#f0f0f0"
                        },
                        "&:hover": {
                            background: "#fcf9f9"
                        },
                        maxHeight: 'none !important',
                    },
                    ".MuiDataGrid-pinnedColumnHeaders": {
                        backgroundColor:backgroundHeaderCustom
                      },
                    " .MuiDataGrid-columnHeaders": {
                        background: backgroundHeaderCustom,
                        // maxHeight:'none !important',
                        ...sxCustomHeader,
                        ".MuiCheckbox-root": {
                            ...sxCustomHeader,
                        }
                    },
                    " .MuiDataGrid-cell": {
                        color: "#333333",
                        lineHeight: 'unset !important',
                        maxHeight: 'none !important',
                        whiteSpace: 'normal',
                        wordWrap: 'break-word',
                        // backgroundColor: "white",
                        py: '8px',
                    },
                    " .MuiDataGrid-footerContainer": {
                        // backgroundColor: "white",
                        overflowX: "auto",
                        overflowY: "hidden",
                        maxWidth: "100vw",
                        justifyContent:'end'
                    },
                    ".MuiDataGrid-columnHeader, .MuiDataGrid-cell": {
                        borderRight: `1px solid rgba(224, 224, 224, 1)`,
                    },
                    " .MuiDataGrid-columnSeparator": {
                        opacity: "0!important",
                    },
                    " .MuiDataGrid-columnsContainer, .MuiDataGrid-cell": {
                        borderBottom: `1px solid rgba(224, 224, 224, 1)`,
                    },
                    " .row-odd": {
                        bgcolor: "#F1F1F1",
                    },
                    // ".MuiDataGrid-row--lastVisible, .MuiDataGrid-cell": {
                    //     // change on 17/06/2022
                    //     // borderColor:"#e0e0e0 ! important"
                    //     borderColor: "#fcf8f8 ! important"
                    // },
                    ".MuiTypography-root": {
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis"
                      },
                      ".MuiDataGrid-cell:focus, .MuiDataGrid-columnHeader:focus": {
                        outline: "none"
                      },
                    ".css-hepa4m-MuiSvgIcon-root": {
                        ...sxCustomHeader
                    },
                    ...sxCustomTable,
                }}
            />
        </>
    );
}
DataGridMuiClient.defaultProps = {
    isShowCheckBox: false,
    disableColumnMenu: true,
    lstPageSize: [10, 25, 50, 100],
    // backgroundHeaderCustom: "#eeeeee",
    backgroundHeaderCustom: "#004290",
    maxRowNoScroll: 5,
    minHeightCustom: 500,
    onCickRow: () => { },
    HiddenToolHead: false,
    sxCustomHeader: { color: '#ffffff' }
};

DataGridMuiClient.propTypes = {
    rows: PropTypes.any,
    HiddenToolHead: PropTypes.bool,
    Columns: PropTypes.array.isRequired,
    isLoading: PropTypes.bool,
    isShowCheckBox: PropTypes.bool,
    disableColumnMenu: PropTypes.bool,
    isNotShowTotal: PropTypes.bool,
    isNotShowPagination: PropTypes.bool,
    lstPageSize: PropTypes.array,
    backgroundHeaderCustom: PropTypes.string,
    sxCustomHeader: PropTypes.any,
    sxCustomTable: PropTypes.any,
    maxRowNoScroll: PropTypes.number,
    minHeightCustom: PropTypes.number,
    onCickRow: PropTypes.func,
    isCustomOnFilter: PropTypes.bool,
    onFilterCustom: PropTypes.func,
    isRowSelectable: PropTypes.func,
    id: PropTypes.string,
    rowReordering: PropTypes.bool,
    onRowOrderChange: PropTypes.func,
    hideFooter: PropTypes.bool,
    initialState: PropTypes.any, 
};
